module.exports = __webpack_public_path__ + "static/img/groundincease1.cd7a3b21.png";